import isInKwaiying from '../isInKwaiying';
import getCookies from '../getCookies';
import getUserInfo from '../getUserInfo';
export default async () => {
    if (isInKwaiying()) {
        const userId = await getCookies('userId');
        return Boolean(userId);
    }
    else {
        // 端外的前端域名多样化，不一定能拿到cookie，一定要发请求确认
        const res = await getUserInfo();
        return res.result === 1;
    }
};
